import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';

import { BsClipboardDataFill } from 'react-icons/bs';
import { FaRegUser } from 'react-icons/fa';
import { VscPreview } from 'react-icons/vsc';
import { RiSecurePaymentFill } from 'react-icons/ri';
import { MdOutlineLocalShipping } from 'react-icons/md';
import { GiConfirmed } from 'react-icons/gi';

import css from './HowItWorksSection.module.css';

const STEPS = [
  {
    icon: BsClipboardDataFill,
    titleId: 'landing.howItWorks.step1Title',
    descId: 'landing.howItWorks.step1Desc',
  },
  {
    icon: FaRegUser,
    titleId: 'landing.howItWorks.step2Title',
    descId: 'landing.howItWorks.step2Desc',
  },
  {
    icon: VscPreview,
    titleId: 'landing.howItWorks.step3Title',
    descId: 'landing.howItWorks.step3Desc',
  },
  {
    icon: RiSecurePaymentFill,
    titleId: 'landing.howItWorks.step4Title',
    descId: 'landing.howItWorks.step4Desc',
  },
  {
    icon: MdOutlineLocalShipping,
    titleId: 'landing.howItWorks.step5Title',
    descId: 'landing.howItWorks.step5Desc',
  },
  {
    icon: GiConfirmed,
    titleId: 'landing.howItWorks.step6Title',
    descId: 'landing.howItWorks.step6Desc',
  },
];

/**
 * HowItWorksSection — horizontal 6-step process flow for the ChinaDolphins landing page.
 */
const HowItWorksSection = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <section className={classes} id="howItworks">
      <div className={css.header}>
        <h2 className={css.title}>
          <FormattedMessage id="landing.howItWorks.title" />
        </h2>
      </div>

      <div className={css.flow}>
        {STEPS.map((step, index) => {
          const Icon = step.icon;
          return (
            <React.Fragment key={index}>
              <div className={css.step}>
                <div className={css.iconBox}>
                  <Icon size={28} />
                </div>
                <div className={css.stepLabel}>
                  <span className={css.stepNum}>{index + 1}</span>
                  <h3 className={css.stepTitle}>
                    <FormattedMessage id={step.titleId} />
                  </h3>
                </div>
                <p className={css.stepDesc}>
                  <FormattedMessage id={step.descId} />
                </p>
              </div>

              {index < STEPS.length - 1 && (
                <div className={css.arrow}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5 12h14M13 6l6 6-6 6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </section>
  );
};

HowItWorksSection.defaultProps = {
  className: null,
  rootClassName: null,
};

HowItWorksSection.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default HowItWorksSection;
